const _temp0 = require("./concentration.svg");
const _temp1 = require("./ebitda_performance.svg");
const _temp2 = require("./fcf_profile.svg");
const _temp3 = require("./market_size_and_performance.svg");
const _temp4 = require("./other.svg");
const _temp5 = require("./overview.svg");
const _temp6 = require("./revenue_performance.svg");
module.exports = {
  "concentration": _temp0,
  "ebitda_performance": _temp1,
  "fcf_profile": _temp2,
  "market_size_and_performance": _temp3,
  "other": _temp4,
  "overview": _temp5,
  "revenue_performance": _temp6
}